var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sButton',{attrs:{"data-qa":"btn-tender-complete","disabled":_vm.disabled,"loading":_vm.loading},on:{"click":_vm.completeTender}},[_vm._v(" "+_vm._s(_vm.$t(`Tenders.Complete`))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }